<template>
  <section class="section">
    <img class="leaf" src="../../../../src/assets/images/leaves/l8.png" align="left"/>
    <div class="items-center">
      <h3 class="section--h3">Features designed for you</h3>
      <p class="section--p">GetBoarded is an intelligent way to build your infographic portfolio & get yourself hooked to opportunities. With powerful research backed algorithms behind, we build</p>
      <vs-row class="container personality-row" vs-type="flex">
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 text-left">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <img src="../../../../src/assets/images/icons/university-features/structured-resumes.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="text-left">
              <h4 class="feature-title mb-3">Structured Resumes</h4>
              <span class="feature-description">Organized resumes that make your student profiles look good on all devices (desktops, tablets, and phones). Responsive resume formats, created with HRs in mind.</span>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 text-left">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: linear-gradient(142.84deg, #F29300 13.39%, #FFD088 126.6%);"
              >
                <img src="../../../../src/assets/images/icons/university-features/saas-analysis.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="text-left">
              <h4 class="feature-title mb-3">SaaS Analysis</h4>
              <span class="feature-description">Enable personality analysis for each student and provide them self-help career guides. Add another dimension to the campus hiring process with personality and career inclination attributes.</span>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 text-left">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <img src="../../../../src/assets/images/icons/university-features/culture-reports.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="text-left">
              <h4 class="feature-title mb-3">Culture Reports</h4>
              <span class="feature-description">With an adhoc snapshot, you can review the aggregated university culture on a holistic level. Creative, Mathematical and Practical. Identify your cultural gaps and training needs.</span>
            </div>
          </vs-card>
        </vs-col>
        <vs-col class="sm:w-full lg:w-1/2 p-5" vs-type="flex" vs-justify="center" vs-align="center">
          <vs-card class="personality-card p-4 mb-2 text-left">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(--vs-primary),0.15);"
              >
                <img src="../../../../src/assets/images/icons/university-features/targeted-opportunities.svg" alt="p.title" width="40px" height="40px" />
              </span>
            </div>
            <div class="text-left">
              <h4 class="feature-title mb-3">Targeted Opportunities</h4>
              <span class="feature-description">Open early career opportunities for your students using our curated feed. Add your own programs and manage student applications effectively</span>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
  import personality_data from '../../../../src/assets/data/personality.js';

  export default {
    name: "Features",
    data() {
      return {
        personality_data: personality_data
      }
    }
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
  section {
    position: relative;
    padding: 5rem;
    background: #FFFFFF;
  }
  section p{
    margin-bottom: 5rem;
  }

  /*===============================================*/
  /* PERSONALITY	 						 */
  /*===============================================*/

  .leaf {
    position: absolute;
    left: 0;
    top: 0;
    width: 700px;
  }

  .personality-row {
    /*margin-top: 10rem;*/
    width: 75%!important;
  }

  .personality-card {
    min-height: 225px;
    z-index: 999;
    box-shadow: 0px 4px 36px rgba(24, 144, 251, 0.1);
  }

  .feature-title {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 38px;

    flex: none;
    order: 0;
    align-self: flex-start;
    flex-grow: 0;
    margin: 0px 0px;
    color: #231D4F;
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;

    flex: none;
    order: 1;
    align-self: flex-start;
    flex-grow: 0;
    color: #848199;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 12rem 2rem 5rem 2rem;
      background: #FFFFFF;
    }
    .section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .leaf {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .personality-row {
      margin-top: 5rem;
    }
  }
</style>
